import styled, { keyframes } from 'styled-components'
// themes
import { colors } from 'themes/index'
// views
import { ButtonsWrapper } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
import { AiButtonsWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/AiControlButton/views'

const stickyHeader = keyframes`
  from { transform: translateY(0px); }
  to { transform: translateY(var(--max-translate, 0px)); }
`

export const TableHeadLabelWrapper = styled.div`
  padding: 2px 4px 0;
  background-color: ${colors.gray190};
  z-index: 1;
  height: 38px;
  min-height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @supports (animation-timeline: scroll()) {
    animation-name: ${stickyHeader};
    animation-timing-function: linear;
    animation-fill-mode: both;
    animation-duration: auto;
    animation-timeline: --rt-scroll;
    animation-range: var(--range-start, 0px) var(--range-end, 0px);
  }

  ${ButtonsWrapper} {
    display: none;
    top: 0;
  }

  &:hover {
    ${ButtonsWrapper} {
      display: flex;
      right: 0;
    }
  }

  ${AiButtonsWrapper} {
    display: none;
  }

  &:hover {
    ${AiButtonsWrapper} {
      display: flex;
    }
  }
`

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const Label = styled.div`
  color: ${colors.gray380};
  font-weight: bold;
  max-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  white-space: nowrap;
`
